export default __webpack_public_path__ + "static/media/TW.11cd340a.svg";